// src/services/api.ts
import axios from 'axios';

//const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
const baseURL = process.env.REACT_APP_API_URL || 'https://sanlaw.sanaaba.org/api';
// 1. إعداد النسخة الأساسية من Axios (Axios Instance)
console.log(`API calls will be made to: ${baseURL}` ); // لسهولة التصحيح في المتصفح
const apiClient = axios.create({
  // افترض أن الخادم يعمل على المنفذ 3001، قم بتغييره إذا كان مختلفاً
  baseURL: baseURL, // المسار الأساسي لكل الطلبات
  headers: {
    'Content-Type': 'application/json',
  },
} );

// 2. إعداد معترض الطلبات (Request Interceptor)
// هذا مفيد جداً لإضافة التوكن (token) الخاص بالمصادقة إلى كل طلب بشكل تلقائي
apiClient.interceptors.request.use(
  (config) => {
    // سنقوم لاحقاً بجلب التوكن من مكان ما (مثل localStorage أو AuthContext)
    const token = localStorage.getItem('authToken'); 
    if (token) {
      // إذا وجد التوكن، أضفه إلى ترويسة الطلب
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // في حال حدوث خطأ أثناء إعداد الطلب
    return Promise.reject(error);
  }
);

// 3. إعداد معترض الاستجابات (Response Interceptor) - اختياري
// يمكن استخدامه للتعامل مع الأخطاء العامة (مثل خطأ 401 Unauthorized) في مكان واحد
apiClient.interceptors.response.use(
  (response) => {
    // أي استجابة ناجحة (status code 2xx) ستمر من هنا
    return response;
  },
  (error) => {
    // التعامل مع الأخطاء
    if (error.response && error.response.status === 401) {
      // على سبيل المثال: إذا كانت الاستجابة 401 (غير مصرح به)
      // يمكننا هنا حذف التوكن القديم وإعادة توجيه المستخدم لصفحة تسجيل الدخول
      localStorage.removeItem('authToken');
      // window.location.href = '/login'; // سنستخدم react-router-dom لاحقاً لهذا
      console.error("Unauthorized! Redirecting to login...");
    }
    return Promise.reject(error);
  }
);

export default apiClient;
